export const ImpersonatedUserId = 'impersonatedUserId';
export const ImpersonatedUserEmail = 'impersonatedUserEmail';
